import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

import { AppConstant } from "src/app/app.const";
import { DxDataGridComponent } from "devextreme-angular";
import { MatDialog } from "@angular/material/dialog";
import { OrderDetailComponent } from "./dialog/order.detail.component";
import { OrderTransferComponent } from "./dialog/order.transfer.component";
import { SalesService } from "../sales.service";
import notify from "devextreme/ui/notify";
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import * as moment from "moment";
declare var $: any;

@Component({
  selector: "app-sales-inquiry",
  templateUrl: "./sales-inquiry.component.html",
  styleUrls: ["./sales-inquiry.component.scss"],
})
export class SalesInquiryComponent implements OnInit {
  isGeneratingReport: boolean = false;
  totalOrderQTY: any;
  totalIssuedQTY: any;
  totalOrders: any;
  // resultList: any[];
  correctDate: boolean;
  orderTypeList: any[];
  rows: any[];
  temp: any[];
  loading: boolean;
  // subBrandList: any[] = [];
  brandMasterList: any[] = [];
  branchList: any[] = [];
  salesInquiryForm: FormGroup;
  cancelOrderList: any[] = [];
  validator1: any;
  validator2: any;
  convertedRows: any[];
  loadingCustomer: boolean;
  customerList: any[];
  tempCustomerList: any[];
  filterList = ["Active", "Inactive"];
  appCons: AppConstant;
  customerId: any;
  @ViewChild("salesInquiryGrid") salesInquiryGrid: DxDataGridComponent;
  collapse: boolean;
  chips: any[];
  // loadingSphRange: boolean;
  // loadingCylRange: boolean;
  // loadingAddfRange: boolean;
  // sphRangeList: any[];
  // addfRangeList: any[];
  // cylRangeList: any[];
  selectedCompanyBranchId: any;
  // activeList: any;
  constructor(private salesService: SalesService, public dialog: MatDialog) {}

  ngOnInit() {
    // this.activeList = [
    //   {
    //     name: "Active",
    //     value: true,
    //   },
    //   {
    //     name: "Inactive",
    //     value: false,
    //   },
    // ];
    this.selectedCompanyBranchId = JSON.parse(
      localStorage.getItem("selectedCustomerBranch")
    ).companyBranchId;
    this.customerId = JSON.parse(
      localStorage.getItem("selectedCustomerBranch")).customerId;
    this.collapse = true;
    this.rows = [];
    this.temp = [];
    this.chips = [];
    // this.sphRangeList = [];
    // this.addfRangeList = [];
    // this.cylRangeList = [];
    this.salesService.registerTabIndex();
    this.productionInquiryFormInitialize();
    const defaultCustomerBranchId = JSON.parse(localStorage.getItem("selectedCustomerBranch"))?.customerBranchId;
    if (defaultCustomerBranchId) {
       this.salesInquiryForm.get("customerBranchId")?.setValue(defaultCustomerBranchId);
       this.salesInquiryForm.get("customerBranchId")?.disable();
    }
    this.getAllCompanyBranchesByUserId();
    this.getCustomerBrandMaster(this.customerId, true, true, false );
    this.getAllSalesOrderType();
    // this.getSalesInquiryList();
    // this.getAllResult();
    // this.getSPH(-35, 30);
    // this.getCYL(-30, +35);
    // this.getADDF(0.25, 6);
    this.getAllCompanyBranchByCustomerId(JSON.parse(localStorage.getItem("selectedCustomerBranch")).customerId, JSON.parse(localStorage.getItem("userData")).id);
    this.correctDate = true;
    this.convertedRows = [];
    this.customerList = [];
    this.tempCustomerList = [];
    // this.getSalesInquiryList();
  }

  /**
   * @name getAllCompanyBranchesByUserId
   * @returns Promise
   * @description fetch all branches
   */
  productionInquiryFormInitialize() {
    this.salesInquiryForm = new FormGroup({
      companyBranchId: new FormControl([], []),
      salesOrderNo: new FormControl("", []),
      brandId: new FormControl(0, []),
      // subBrandId: new FormControl(0, []),
      // cancelOrderId: new FormControl('', []),
      orderTypeId: new FormControl(0, []),
      // resultId: new FormControl(0, []),
      fromDate: new FormControl(moment(new Date()).format("YYYY-MM-DDT00:00:00"), []),
      toDate: new FormControl(moment(new Date()).format("YYYY-MM-DDT23:59:00"), []),
      poNumber: new FormControl(null, []),
      customerBranchId: new FormControl(0, [Validators.required]),
      includeDateFilter: new FormControl(true, []),
      // sph: new FormControl(null, []),
      // cyl: new FormControl(null, []),
      // add: new FormControl(null, []),
      active: new FormControl(true, []),
    });
    const itemInterval = setInterval(() => {
        this.getCustomerCompanyBranchId([this.selectedCompanyBranchId]);
        clearInterval(itemInterval);
    }, 1000);

  }

  /**
   * @name getSPH
   * @param {number} range1
   * @param {number} range2
   * @returns sph range
   * @memberof salesService
   */
  // getSPH(range1: number, range2: number) {
  //   this.loadingSphRange = true;
  //   this.salesService
  //     .getSPH(range1, range2)
  //     .then((response) => {
  //       if (response.data.completed) {
  //         if (response.data.payload.length > 0) {
  //           const list = [];
  //           response.data.payload.forEach((element) => {
  //             if (element.active) {
  //               list.push(element);
  //             }
  //           });
  //           this.sphRangeList = list;
  //         } else {
  //           if (response.data.payload.active) {
  //             this.sphRangeList = response.data.payload;
  //           }
  //         }
  //         this.loadingSphRange = false;
  //       }
  //     })
  //     .catch((err) => {
  //       this.loadingSphRange = false;
  //       console.log("err ", err);
  //     });
  // }
  /**
   * @name getCYL
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  // getCYL(range1: number, range2: number) {
  //   this.loadingCylRange = true;
  //   this.salesService
  //     .getCYL(range1, range2)
  //     .then((response) => {
  //       if (response.data.completed) {
  //         if (response.data.payload.length > 0) {
  //           const list = [];
  //           response.data.payload.forEach((element) => {
  //             if (element.active) {
  //               list.push(element);
  //             }
  //           });
  //           this.cylRangeList = list;
  //         } else {
  //           if (response.data.payload.active) {
  //             this.cylRangeList = response.data.payload;
  //           }
  //         }
  //         this.loadingCylRange = false;
  //       }
  //     })
  //     .catch((err) => {
  //       this.loadingCylRange = false;
  //       console.log("err ", err);
  //     });
  // }
  /**
   * @name getADDF
   * @param {number} range1
   * @param {number} range2
   * @returns addf range
   * @memberof salesService
   */
  // getADDF(range1: number, range2: number) {
  //   this.loadingAddfRange = true;
  //   this.salesService
  //     .getADDF(range1, range2)
  //     .then((response) => {
  //       if (response.data.completed) {
  //         if (response.data.payload.length > 0) {
  //           const list = [];
  //           response.data.payload.forEach((element) => {
  //             if (element.active) {
  //               list.push(element);
  //             }
  //           });
  //           this.addfRangeList = list;
  //         } else {
  //           if (response.data.payload.active) {
  //             this.addfRangeList = response.data.payload;
  //           }
  //         }
  //         this.loadingAddfRange = false;
  //       }
  //     })
  //     .catch((error) => {
  //       this.loadingAddfRange = false;
  //       const option = {
  //         width: 300,
  //         displayTime: 5000,
  //         message: error.message,
  //         type: "error",
  //       };
  //       console.log(error);
  //       notify(option);
  //     });
  // }

  onInitialized1(e: any) {
    this.validator1 = e.component;
  }
    /**
   * @name getCustomerCompanyBranchId
   * @param {number} companyBranchId
   * @reutrn Customer list
   */
    getCustomerCompanyBranchId(companyBranchId: any) {
      if (companyBranchId.length > 0) {
        this.customerList = [];
        this.tempCustomerList = [];
        this.loadingCustomer = true;
        this.salesService
          .getCustomerCompanyBranchId(
            companyBranchId[0],
            JSON.parse(localStorage.getItem("userData")).id
          )
          .then((response) => {
            this.loadingCustomer = false;

            if (response.data.completed) {
              if (response.data.payload.length > 0) {
                const list = [];
                response.data.payload.forEach((element) => {
                  if (element.active) {
                    list.push(element);
                  }
                });
                this.customerList = list;
                this.tempCustomerList = list;
                // this.filterCustomer(1);
              } else {
                if (response.data.payload.active) {
                  this.customerList = response.data.payload;
                  this.tempCustomerList = response.data.payload;
                  // this.filterCustomer(1);
                }
              }
            }
            
          })
          .catch((err) => {
            this.loadingCustomer = false;
            console.error("Error:  ", err);
          });
      }
    }
  onValueChanged1(e: any) {
    if (this.validator2) {
      this.validator2.validate();
    }
  }
  onInitialized2(e: any) {
    this.validator2 = e.component;
  }
  onValueChanged2(e: any) {
    if (this.validator1) {
      this.validator1.validate();
    }
  }
  /**
   * @name dateValidation
   * @returns void
   * @description validate date
   */
  dateValidation = () => {
    let fromDate = this.salesInquiryForm.get("fromDate").value;
    let toDate = this.salesInquiryForm.get("toDate").value;
    //if we have either start or end validate, else not required and return true.
    if (fromDate && toDate) {
      //start date must come before end date
      if (toDate < fromDate || fromDate > toDate) {
        this.correctDate = false;
        return false;
      } else {
        this.correctDate = true;
        return true;
      }
    } else {
      return true;
    }
  }

  /**
   * @name getAllCompanyBranchByCustomerId
   * @param {number} customerId
   * @reutrn Customer list
   */
   getAllCompanyBranchByCustomerId(customerId: number, userId: number) {
    if (customerId && userId) {
      this.customerList = [];
    this.tempCustomerList = [];
    this.loadingCustomer = true;
    this.salesService
      .getAllCompanyBranchByCustomerId(customerId, userId)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.customerList = list;
            this.tempCustomerList = list;
            // this.filterCustomer(1);
          } else {
            if (response.data.payload.active) {
              this.customerList = response.data.payload;
              this.tempCustomerList = response.data.payload;
              // this.filterCustomer(1);
            }
          }
        }
        this.loadingCustomer = false;
      })
      .catch((err) => {
        this.loadingCustomer = false;
        console.error("Error:  ", err);
      });
    }
    
  }

  /**
   *@name  filterProvinces
   *@param {number} countryId
   *@desc filters province list according to countryId
   */
  //  filterCustomer(customerTypeId?: any, customerTypeEvent?: any) {
  //   this.customerList = [];
  //   if (this.tempCustomerList) {
  //     let filteredCustomers = this.tempCustomerList.filter((x) => {
  //       return x.customerTypeId === customerTypeId;
  //     });
  //     this.customerList = filteredCustomers;
  //   }
  // }

  /**
   * @name getAllCompanyBranchesByUserId
   * @returns Promise
   * @description fetch all branches
   */
  getAllCompanyBranchesByUserId() {
    
    const userDataRaw = localStorage.getItem("userData");
    if (!userDataRaw) {
      console.warn("userData not found in localStorage");
      return;
    }
  
    const userData = JSON.parse(userDataRaw);
    this.branchList = userData?.customerBranch || [];
  }

  /**
   * @name getAllBrandMasters
   * @returns Promise
   * @description fetch all brand master
   */
  getCustomerBrandMaster(customerId: number, isRx: boolean,isStock: boolean, isOther: boolean) {
    this.salesService
      .getCustomerBrandMaster(customerId, isRx, isStock, isOther)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.brandMasterList = list;
          } else {
            if (response.data.payload.active) {
              this.brandMasterList = response.data.payload;
            }
          }
        } else {
          this.loading = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
        }
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }

  /**
   * @name getAllSubBrandsByBrandMasterId
   * @param brandMasterId
   * @returns Promise
   * @description fetch all branches
   */
  // getAllSubBrandsByBrandMasterId(brandMasterId: number) {
  //   this.subBrandList = [];
  //   this.salesInquiryForm.get("subBrandId").setValue(0);
  //   if (brandMasterId) {
  //     this.loading = true;
  //     this.salesService
  //       .getAllSubBrandsByBrandMasterId(brandMasterId)
  //       .then((response) => {
  //         if (response.data.completed) {
  //           if (response.data.payload.length > 0) {
  //             const list = [];
  //             response.data.payload.forEach((element) => {
  //               if (element.active) {
  //                 list.push(element);
  //               }
  //             });
  //             this.subBrandList = list;
  //             this.loading = false;
  //           } else {
  //             if (response.data.payload.active) {
  //               this.subBrandList = response.data.payload;
  //               this.loading = false;
  //             }
  //           }
  //         } else {
  //           this.loading = false;
  //           const option = {
  //             width: 300,
  //             displayTime: 3000,
  //             message: response.data.message,
  //             type: "error",
  //           };
  //           notify(option);
  //         }
  //       })
  //       .catch((error) => {
  //         this.loading = false;
  //         console.log(error);
  //         const option = {
  //           width: 300,
  //           displayTime: 3000,
  //           message: error.message,
  //           type: "error",
  //         };
  //         notify(option);
  //       });
  //   }
  // }

  /**
   * @name getAllSalesOrderType
   * @param
   * @returns Promise
   * @description fetch all branches
   */
  // getAllSalesOrderType() {
  //   this.salesService
  //     .getAllSalesOrderType()
  //     .then((response) => {
  //       if (response.data.completed) {
  //         const list = [];
  //         if (response.data.payload.length > 0) {
            
  //           response.data.payload.forEach((element) => {
  //             if (element.salesOrderTypeId == 1 || element.salesOrderTypeId == 5 || element.salesOrderTypeId == 3) {
  //               list.push(element);
  //             }
  //           });
  //           this.orderTypeList = list;
  //         } else {
  //           if (response.data.payload.active) {
  //             response.data.payload.forEach((element) => {
  //               if (element.salesOrderTypeId == 1 || element.salesOrderTypeId == 5 || element.salesOrderTypeId == 3) {
  //                 list.push(element);
  //               }
  //             });
  //             this.orderTypeList = list;
  //           }
  //         }
  //       } else {
  //         this.loading = false;
  //         const option = {
  //           width: 300,
  //           displayTime: 3000,
  //           message: response.data.message,
  //           type: "error",
  //         };
  //         notify(option);
  //       }
  //     })
  //     .catch((error) => {
  //       this.loading = false;
  //       console.log(error);
  //       const option = {
  //         width: 300,
  //         displayTime: 3000,
  //         message: error.message,
  //         type: "error",
  //       };
  //       notify(option);
  //     });
  // }
  getAllSalesOrderType() {
  this.salesService
    .getAllSalesOrderType()
    .then((response) => {
      if (response.data.completed) {
        const list = [];
        const companyId = JSON.parse(localStorage.getItem("selectedCustomerBranch"))?.companyId;

        if (response.data.payload?.length > 0) {
          response.data.payload.forEach((element) => {
            const id = element.salesOrderTypeId;

            const isStockOrder = id === 1;
            const isJobOrder = id === 5;
            const isFittingOrder = id === 3;

            if (companyId === 2) {
              if (isStockOrder || isJobOrder || isFittingOrder) {
                list.push(element);
              }
            } else {
              if (isStockOrder || isJobOrder) {
                list.push(element);
              }
            }
          });
        } else if (response.data.payload?.active) {
          response.data.payload.forEach((element) => {
            const id = element.salesOrderTypeId;
            const isStockOrder = id === 1;
            const isJobOrder = id === 5;
            const isFittingOrder = id === 3;

            if (companyId === 2) {
              if (isStockOrder || isJobOrder || isFittingOrder) {
                list.push(element);
              }
            } else {
              if (isStockOrder || isJobOrder) {
                list.push(element);
              }
            }
          });
        }

        this.orderTypeList = list;
      } else {
        this.loading = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: response.data.message,
          type: "error",
        };
        notify(option);
      }
    })
    .catch((error) => {
      this.loading = false;
      console.error(error);
      const option = {
        width: 300,
        displayTime: 3000,
        message: error.message,
        type: "error",
      };
      notify(option);
    });
}


  /**
   * @name getAllResult
   * @param
   * @returns Promise
   * @description fetch all results
   */
  // getAllResult() {
  //   this.salesService
  //     .getAllResult()
  //     .then((response) => {
  //       if (response.data.completed) {
  //         if (response.data.payload.length > 0) {
  //           const list = [];
  //           response.data.payload.forEach((element) => {
  //             if (element.active) {
  //               list.push(element);
  //             }
  //           });
  //           this.resultList = list;
  //         } else {
  //           if (response.data.payload.active) {
  //             this.resultList = response.data.payload;
  //           }
  //         }
  //       } else {
  //         this.loading = false;
  //         const option = {
  //           width: 300,
  //           displayTime: 3000,
  //           message: response.data.message,
  //           type: "error",
  //         };
  //         notify(option);
  //       }
  //     })
  //     .catch((error) => {
  //       this.loading = false;
  //       console.log(error);
  //       const option = {
  //         width: 300,
  //         displayTime: 3000,
  //         message: error.message,
  //         type: "error",
  //       };
  //       notify(option);
  //     });
  // }
  applyFilter(filterType?, values?) {}

  /**
   * @name generateSalesOrderReport
   * @returns void
   * @description Generate Report
   */
  generateReport(saleOrderId: number, isUpdate: boolean) {
    if (saleOrderId > 0) {
      this.isGeneratingReport = true;
      let payload = {
        moduleId: 1,
        reportConfigurationId: 18,
        recordNo: saleOrderId,
        customerId: 0,
        customerBranchId: 0,
        brandMasterId: [],
        driverId: 0,
        fromDate: new Date(),
        toDate: new Date(),
        fileType: 1,
        companyBranchId: [],
        salesOrderTypeId: [],
        accountHeadDetailTypeId: null,
        accountId: null,
        companyId: JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
        activeOrder: false,
      };
      this.salesService
        .generateReport(payload)
        .then((res: any) => {
          window.open(res.data.payload, "_blank");
           this.isGeneratingReport = false;
        })
        .catch((error) => {
          this.isGeneratingReport = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          notify(option);
        });
    }
  }

  /**
   * @name accessGenerateReport
   * @param salesOrderTypeId
   * @returns
   */
  accessGenerateReport(salesOrderTypeId: number) {
    if (salesOrderTypeId == 5 || salesOrderTypeId == 1 || salesOrderTypeId == 3) {
      return true;
    } else {
      return false;
    }
  }
  private formatLocalDate(date: Date): string {
    const pad = (n: number) => (n < 10 ? '0' + n : n);
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds())
    );
  }
  
  
  /**
   * @name getAllTimeMonitoringProcessWise
   * @param
   * @returns  Time Monitoring Process Wise Data
   */
  getSalesInquiryList(salesInquiryForm?: FormGroup) {
    this.getChips();
    this.salesInquiryGrid.instance.clearFilter();
    if (this.correctDate) {
      this.loading = true;
      if (
        this.salesInquiryForm.get("salesOrderNo").value ||
        this.salesInquiryForm.get("poNumber").value
      ) {
        this.salesInquiryForm.get("includeDateFilter").setValue(false);
        this.salesInquiryForm.get("companyBranchId").setValue([]);
        this.salesInquiryForm.get("customerBranchId").setValue(null);
      }
     
      const formBranchIds = this.salesInquiryForm.get("companyBranchId").value;
   const selectedBranchIds = (formBranchIds && formBranchIds.length > 0)
  ? formBranchIds
  : this.branchList.map(b => b.customerBranchId);
      const payload = {
        fromDate: null,
        toDate: null,
        branchIds:null,
        salesOrderNo: this.salesInquiryForm.get("salesOrderNo").value
          ? this.salesInquiryForm.get("salesOrderNo").value
          : 0,
        brandId: this.salesInquiryForm.get("brandId").value
          ? this.salesInquiryForm.get("brandId").value
          : 0,
        subBrandId: 0,
        orderTypeId: this.salesInquiryForm.get("orderTypeId").value
          ? this.salesInquiryForm.get("orderTypeId").value
          : 0,
        resultId: 0,
        // fromDate: this.salesInquiryForm.get("fromDate").value
        //   ? this.salesInquiryForm.get("fromDate").value
        //   : null,
        // toDate: this.salesInquiryForm.get("toDate").value
        //   ? this.salesInquiryForm.get("toDate").value
        //   : null,
        poNumber: this.salesInquiryForm.get("poNumber").value
          ? this.salesInquiryForm.get("poNumber").value
          : null,
        sph: null,
        cyl: null,
        add: null,
        customerBranchId: this.salesInquiryForm.get("customerBranchId").value
        ? this.salesInquiryForm.get("customerBranchId").value
        : 0,
        customerBranchIds: selectedBranchIds.toString(),
          customerId: JSON.parse(
            localStorage.getItem("selectedCustomerBranch")
          ).customerId,
        active: this.salesInquiryForm.get("active").value,
        currentStatus: false,
        isInvoiced:false,
        isPending: false,
        includeDateFilter: this.salesInquiryForm.get("includeDateFilter").value
      };
      let f = this.salesInquiryForm.get("fromDate").value;
      let t = this.salesInquiryForm.get("toDate").value;
      payload.fromDate = f;
      payload.toDate = t;

      if (!this.salesInquiryForm.get("includeDateFilter").value) {
        payload.fromDate = null;
        payload.toDate = null;
      }
      this.salesService
        .getCustomerSalesInquiry(payload)
        .then((response: any) => {
          if (response.data.completed) {
            this.rows = response.data.payload.salesInquiry;
            this.temp = response.data.payload.salesInquiry;
            if (
              response.data.payload.salesInquiry &&
              response.data.payload.salesInquiry.length > 0
            ) {
              this.collapse = false;
            } else {
              this.collapse = true;
            }
            this.convertedRows = this.convertGroup(this.rows);
            this.convertedRows.map((item, index) => {
              item["rowIndex"] = index;
            });
            this.rows.map((item, i) => {
              item["srNo"] = i + 1;
              switch (item.currentStatus) {
                case "Invoiced":
                  item["color"] = "#625";
                  break;
                case "In branch":
                  item["color"] = "#725";
                  break;
                case "Production OUT":
                  item["color"] = "#835";
                  break;
                case "Fitting OUT":
                  item["color"] = "#223";
                  break;
                case "In Frame Fitting ":
                  item["color"] = "#968";
                  break;
                case "MCQC":
                  item["color"] = "#557";
                  break;
                case "MC IN":
                  item["color"] = "#249";
                  break;
                case "Oven Allocated":
                  item["color"] = "#195";
                  break;
                case "HC In":
                  item["color"] = "#879";
                  break;
                case "Tint OUT":
                  item["color"] = "#719";
                  break;
                case "Tint QC":
                  item["color"] = "#425";
                  break;
                case "Tint IN":
                  item["color"] = "#896";
                  break;
                case "Rx QC Done":
                  item["color"] = "#735";
                  break;
                case "In Rx":
                  item["color"] = "#867";
                  break;
                case "Order Acknowledged":
                  item["color"] = "#276";
                  break;
                case "Order Booked":
                  item["color"] = "#425";
                  break;
                case "NA":
                  item["color"] = "#689";
                  break;
              }
            });
            // this.rows = new DataSource({
            //   store: r,
            //   paginate: true,
            //   pageSize: 5

            // })

            this.totalOrders = response.data.payload.totalOrders;
            this.totalIssuedQTY = response.data.payload.totalIssuedQTY;
            this.totalOrderQTY = response.data.payload.totalOrderQTY;
            const selectedCustomerBranch = JSON.parse(localStorage.getItem("selectedCustomerBranch"));
            if (selectedCustomerBranch?.customerBranchId) {
              this.salesInquiryForm.get("customerBranchId")?.setValue(selectedCustomerBranch.customerBranchId);
              this.salesInquiryForm.get("customerBranchId")?.disable();
            }
            this.loading = false;
          } else {
            this.collapse = true;
            this.loading = false;
            const option = {
              width: 300,
              displayTime: 3000,
              message: response.data.message,
              type: "error",
            };
            notify(option);
          }
        })
        .catch((error) => {
          this.collapse = true;
          this.loading = false;
          console.log(error);
          const option = {
            width: 300,
            displayTime: 3000,
            message: error.message,
            type: "error",
          };
          notify(option);
        });
    }
  }

  getChips() {
    this.chips = [];
    if (this.salesInquiryForm.get("companyBranchId").value) {
      this.salesInquiryForm.get("companyBranchId").value.forEach((value) => {
        this.branchList.forEach((item) => {
          if (value == item.companyBranchId) {
            let data = {
              name: item.companyBranchName,
              value: item.companyBranchId,
              type: "branchList",
            };
            this.chips.push(data);
          }
        });
      });
    }
    if (this.salesInquiryForm.get("customerBranchId").value) {
      const filterItem = this.customerList.find(
        (item) =>
          item.customerBranchId ==
          this.salesInquiryForm.get("customerBranchId").value
      );
      let data = {
        name:  JSON.parse(localStorage.getItem("selectedCustomerBranch"))?.customerBranchName,
        value:  JSON.parse(localStorage.getItem("selectedCustomerBranch"))?.customerBranchId,
        type: "customerList",
      };
      this.chips.push(data);
    }

    if (this.salesInquiryForm.get("salesOrderNo").value) {
      let data = {
        name:
          "Sales Order #." + this.salesInquiryForm.get("salesOrderNo").value,
        value: this.salesInquiryForm.get("salesOrderNo").value,
        type: "salesOrderNo",
      };
      this.chips.push(data);
    }
    if (this.salesInquiryForm.get("brandId").value) {
      const filterItem = this.brandMasterList.find(
        (item) =>
          item.brandMasterId == this.salesInquiryForm.get("brandId").value
      );
      let data = {
        name: filterItem.brandName,
        value: filterItem.brandMasterId,
        type: "brandMasterList",
      };
      this.chips.push(data);
    }
    // if (this.salesInquiryForm.get("subBrandId").value) {
    //   const filterItem = this.subBrandList.find(
    //     (item) =>
    //       item.subBrandMasterId == this.salesInquiryForm.get("subBrandId").value
    //   );
    //   let data = {
    //     name: filterItem.subBrandName,
    //     value: filterItem.subBrandMasterId,
    //     type: "subBrandList",
    //   };
    //   this.chips.push(data);
    // }
    if (this.salesInquiryForm.get("orderTypeId").value) {
      const filterItem = this.orderTypeList.find(
        (item) =>
          item.salesOrderTypeId ==
          this.salesInquiryForm.get("orderTypeId").value
      );
      let data = {
        name: filterItem.salesOrderTypeName,
        value: filterItem.salesOrderTypeId,
        type: "orderTypeList",
      };
      this.chips.push(data);
    }
    // if (this.salesInquiryForm.get("resultId").value) {
    //   const filterItem = this.resultList.find(
    //     (item) => item.resultId == this.salesInquiryForm.get("resultId").value
    //   );
    //   let data = {
    //     name: filterItem.resultName,
    //     value: filterItem.resultId,
    //     type: "resultList",
    //   };
    //   this.chips.push(data);
    // }
    return this.chips;
  }

  /**
   * @name remove
   * @param item
   * @return void
   */
  remove(item) {
    const index = this.chips.findIndex((o) => o.value == item.value);
    this.chips.splice(index, 1);
    // switch (item.type) {
    //   case 'branchList':
    //         const index = this.chips.findIndex(o => o.value ==  item.value);
    //         this.chips.splice(index, 1);
    //         let tempList = this.salesInquiryForm.get('companyBranchId').value;
    //         const i = tempList.findIndex(o => o ==  item.value);
    //         tempList.splice(i, 1);
    //         this.salesInquiryForm.get('companyBranchId').setValue(tempList);
    //         this.getSalesInquiryList();
    //     break;
    //     case 'salesOrderNo':
    //       const salesOrderIndex = this.chips.findIndex(o => o.value ==  item.value);
    //       this.chips.splice(salesOrderIndex, 1);
    //       this.salesInquiryForm.get('salesOrderNo').setValue(null);
    //       this.getSalesInquiryList();
    //     break;
    // }
  }
  /**
   * @name onRadioChecked
   * @returns filtered rows
   * @description all GRN request data
   */
  onRadioChecked(event) {
    if (event == "Active") {
      this.rows = this.temp.filter((x) => x.active == true);
    } else {
      this.rows = this.temp.filter((x) => x.active == false);
    }
  }

  getVisibleColumn(data, colName) {
    data.columns.forEach((element) => {
      if (element.dataField == colName) {
        return true;
      } else {
        return false;
      }
    });
  }
  /**
   * @name convertGroup
   * @param list
   * @returns converted rows for grouping
   */
  convertGroup(list: any[]) {
    let final = [];
    let g = list.reduce((prev, t, index, arr) => {
      if (typeof prev[t.salesOrderNo] === "undefined") {
        prev[t.salesOrderNo] = [];
      }
      prev[t.salesOrderNo].push(t);
      return prev;
    }, {});
    Object.keys(g).forEach((i) => {
      let array_of_same_id = g[i];
      final.push(array_of_same_id);
    });
    return final;
  }
  /**
   * @name resetFilters
   * @param
   * @returns  Resets all filters and get all data for grid
   */
  resetFilters() {
    const selectedCustomerBranch = JSON.parse(localStorage.getItem("selectedCustomerBranch"));
  const defaultCustomerBranchId = selectedCustomerBranch?.customerBranchId;
    this.productionInquiryFormInitialize();
    if (defaultCustomerBranchId) {
      this.salesInquiryForm.get("customerBranchId")?.setValue(defaultCustomerBranchId);
      this.salesInquiryForm.get("customerBranchId")?.disable();  // Make it readonly again
    }
  
    this.getSalesInquiryList();
  }
  onContentReady(e) {
    e.component.option("loadPanel.enabled", false);
  }

  mergeCells(e) {
    if (e.column.allowMerge && e.rowType == "data") {
      if (e.rowIndex != 0) {
        // tslint:disable-next-line:no-shadowed-variable
        let previousRowCellColumnIndex = e.component.columnOption(
          e.column.dataField,
          "visibleIndex"
        );
        let previousRowValue = e.component.cellValue(
          e.column.MergeCellRowStart,
          previousRowCellColumnIndex
        );
        if (e.displayValue == previousRowValue) {
          e.cellElement.remove();
          if (e.column.MergeCellRowStart == undefined) {
            e.column.MergeCellRowStart = e.rowIndex;
          }
          e.column.MergeCellRowEnd = e.rowIndex;
          if (e.rowIndex == e.component.option("dataSource").length - 1) {
            if (
              e.column.MergeCellRowStart != undefined &&
              e.column.MergeCellRowEnd != undefined
            ) {
              // tslint:disable-next-line:no-shadowed-variable
              let previousRowCellColumnIndex = e.component.columnOption(
                e.column.dataField,
                "visibleIndex"
              );
              let CurrentRowTDCount = e.element
                .find(".dx-data-row")
                .eq(e.column.MergeCellRowStart)
                .find("td")
                .size();
              CurrentRowTDCount = e.component.columnCount() - CurrentRowTDCount;
              if (
                CurrentRowTDCount > 0 &&
                CurrentRowTDCount <= previousRowCellColumnIndex
              ) {
                previousRowCellColumnIndex -= CurrentRowTDCount;
              }
              previousRowCellColumnIndex += $.grep(
                e.component.option("columns"),
                function (node, index) {
                  return e.component.columnOption(index, "groupIndex") > -1;
                }
              ).length;
              // tslint:disable-next-line:no-shadowed-variable
              let previousRowCell = e.component.getCellElement(
                e.column.MergeCellRowStart,
                previousRowCellColumnIndex
              );
              if (previousRowCell.length > 0) {
                // tslint:disable-next-line:no-shadowed-variable
                let rowspan =
                  e.column.MergeCellRowEnd - e.column.MergeCellRowStart + 1;
                previousRowCell.attr("rowspan", rowspan);
                previousRowCell.css({
                  display: "table-cell",
                  "vertical-align": "middle",
                });
              }
            }
          }
        } else {
          if (
            e.column.MergeCellRowStart != undefined &&
            e.column.MergeCellRowEnd != undefined
          ) {
            // tslint:disable-next-line:no-shadowed-variable
            let previousRowCellColumnIndex = e.component.columnOption(
              e.column.dataField,
              "visibleIndex"
            );
            let CurrentRowTDCount = e.element
              .find(".dx-data-row")
              .eq(e.column.MergeCellRowStart)
              .find("td")
              .size();
            CurrentRowTDCount = e.component.columnCount() - CurrentRowTDCount;
            if (
              CurrentRowTDCount > 0 &&
              CurrentRowTDCount <= previousRowCellColumnIndex
            ) {
              previousRowCellColumnIndex -= CurrentRowTDCount;
            }
            previousRowCellColumnIndex += $.grep(
              e.component.option("columns"),
              function (node, index) {
                return e.component.columnOption(index, "groupIndex") > -1;
              }
            ).length;
            let previousRowCell = e.component.getCellElement(
              e.column.MergeCellRowStart,
              previousRowCellColumnIndex
            );
            if (previousRowCell && previousRowCell.length > 0) {
              let rowspan =
                e.column.MergeCellRowEnd - e.column.MergeCellRowStart + 1;
              previousRowCell.attr("rowspan", rowspan);
              previousRowCell.css({
                display: "table-cell",
                "vertical-align": "middle",
              });
            } else {
              console.log(
                e.element
                  .find(".dx-data-row")
                  .eq(e.column.MergeCellRowStart)
                  .find("td")
              );
              console.log(previousRowCell);
            }
          }
          e.column.MergeCellRowStart = e.rowIndex;
          e.column.MergeCellRowEnd = undefined;
        }
      } else {
        if (e.column.MergeCellRowStart == undefined) {
          e.column.MergeCellRowStart = e.rowIndex;
        }
      }
    }
  }

  /**
   * @name deleteSalesOrder
   * @method GET
   * @param {number} salesOrderId
   * @return Promise
   */
  deleteSalesOrder(id) {
    this.loading = true;
    this.salesService
      .deleteSalesOrder(id)
      .then((response: any) => {
        if (response.data.completed) {
          this.loading = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "success",
          };
          notify(option);
          this.getSalesInquiryList(this.salesInquiryForm);
        } else {
          this.loading = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
        }
      })
      .catch((error) => {
        this.loading = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }

  /**
   * @name customizeText
   * @param e
   * @description display summary text
   * @returns void
   */
  customizeTextOrders(e) {
    return "Total Items: " + e.value;
  }

  /**
   * @name customizeText
   * @param e
   * @description display summary text
   * @returns void
   */
  customizeText(e) {
    return "Total: ";
  }

  /**
   * @name customizeTotal
   * @param form
   * @description display summary total
   * @returns void
   */
  customizeTotal(e) {
    console.log(e);
    return e.value;
  }

  calculateSelectedRow(options) {
    if (options.name === "salesOrderNo") {
      if (options.summaryProcess === "start") {
        options.totalValue = 0;
      } else if (options.summaryProcess === "calculate") {
        options.totalValue = 0;

        // if (options.component.isRowSelected(options.value.ID)) {
        //     options.totalValue = options.totalValue + options.value.SaleAmount;
        // }
      }
    }
  }

  distinctOrders() {
    const distinctorders = this.rows.filter((thing, i, arr) => {
      return (
        arr.indexOf(arr.find((t) => t.salesOrderNo === thing.salesOrderNo)) ===
        i
      );
    });
    return distinctorders;
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  /**
   * @name openOrderTransferPopup
   * @return void
   * @description transfer sale order popup
   */
  openOrderTransferPopup() {
    let dialog = this.dialog.open(OrderTransferComponent, {
      width: "300px",
      data: {},
    });
    dialog.afterClosed().subscribe(() => {
//this.getSalesInquiryList(this.salesInquiryForm);
    });
  }

  /**
   * @name openOrderDetailPopup
   * @return void
   * @description transfer sale order popup
   */
  openOrderDetailPopup(salesOrderNo: number) {
    let dialog = this.dialog.open(OrderDetailComponent, {
      panelClass: "full-width-dialog",
      data: this.rows.filter((row) => row.salesOrderNo == salesOrderNo),
    });
    dialog.afterClosed().subscribe(() => {});
  }

  statusHeaderFilter(data) {
    // console.log('data', data)
    // this.rows.forEach((item) => {
    //   data.dataSource.postProcess = (results) => {
    //     results.push({
    //         text: item.currentStatus,
    //         value: item.currentStatus
    //     });
    //     return results;
    // };
    // })
  }

  getCurrentStatus() {
    let currentStatus = null;
    if (this.rows && this.rows.length > 0) {
      this.rows.map((element) => {
        switch (element.currentStatus) {
          case "Invoiced":
            currentStatus = "#625";
            break;
          case "In branch":
            currentStatus = "#625";
            break;
          case "Production OUT":
            currentStatus = "#625";
            break;
          case "Fitting OUT":
            currentStatus = "#625";
            break;
          case "In Frame Fitting ":
            currentStatus = "#625";
            break;
          case "MCQC":
            currentStatus = "#625";
            break;
          case "MC IN":
            currentStatus = "#625";
            break;
          case "Oven Allocated":
            currentStatus = "#625";
            break;
          case "HC In":
            currentStatus = "#625";
            break;
          case "Tint OUT":
            currentStatus = "#625";
            break;
          case "Tint QC":
            currentStatus = "#625";
            break;
          case "Tint IN":
            currentStatus = "#625";
            break;
          case "Rx QC Done":
            currentStatus = "#625";
            break;
          case "In Rx":
            currentStatus = "#625";
            break;
          case "Order Acknowledged":
            currentStatus = "#625";
            break;
          case "Order Booked":
            currentStatus = "#625";
            break;
          case "NA":
            currentStatus = "#625";
            break;
        }
        return currentStatus;
      });
    }
  }

   /**
   * Executes when exporting.
   *
   * @param {Object} e - The event object.
   */
   onExporting(e) {
    e.component.beginUpdate();
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('AllSalesInquiry');

    exportDataGrid({
        component: e.component,
        worksheet: worksheet
    }).then(function() {
        workbook.xlsx.writeBuffer().then(function(buffer: BlobPart) {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AllSalesInquiry.xlsx');
        });
    }).then(function() {
        e.component.endUpdate();
    });
}
}
